export enum Roles {
  SystemAdmin = 'System Administrator',
  SiteAdmin = 'Site Administrator',
  Coordinator = 'Coordinator',
  Supervisor = 'Supervisor',
  Trainer = 'Trainer',
  Mentor = 'Mentor',
  Trainee = 'Trainee',
  Mentee = 'Mentee',
  Employee = 'Employee'
}
